import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'CommonTemplate',
        path: () => path.join(__dirname, './Common'),
        resolve: () => require.resolveWeak('./Common'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "CommonTemplate" */ './Common')]).then(
                (proms) => proms[0]
            ),
    })
);
